import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { ConfigContext } from '../context';

const Icon = (props) => {
  const { config } = useContext(ConfigContext);

  let { alt, icon, className, width, height } = props;

  if(typeof width === 'undefined') {
    width = 21;
  }

  if(typeof height === 'undefined') {
    height = 21;
  }

  // Convert icon name to url
  if (icon.indexOf('/') === -1) {
    icon = `${config.studioUrl}web/assets/${icon}.svg?t=${config.resourceTimestamp}`;
  }

  return <img className={className || 'dealers-icon'} src={icon} alt={alt || ''} width={width} height={height} />;
};

Icon.propTypes = {
  alt: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};


export const IconV2 = (props) => {
  const { icon } = props;
  let { className, width, height } = props;

  if(typeof width === 'undefined') {
    width = 21;
  }

  if(typeof height === 'undefined') {
    height = 21;
  }

  switch (props.icon) {
    case 'filter':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={'d-icon-v2 ' + (className || '')}>
          <path d="M19.686187 0H1.31406C.148189 0-.440057 1.414506.385957 2.24056L7.875 9.731163v7.659463c-.000015.378475.163372.738529.448219.987738l2.625 2.296178c.838277.733482 2.176781.150937 2.176781-.987738v-9.95564l7.489248-7.490602C21.438662 1.416187 20.854395 0 19.686188 0zM11.8125 9.1875v10.5l-2.625-2.296875V9.1875l-7.875-7.875h18.375l-7.875 7.875z" fill="var(--icon-color, currentColor)" fillRule="nonzero"/>
        </svg>
      );
    case 'map':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={'d-icon-v2 ' + (className || '')}>
          <path d="M10.9904 21C11.2772 21 11.5448 20.8698 11.6977 20.6466C11.8889 20.3676 16.5723 13.8388 17.8148 11.8485C18.5986 10.6395 19 9.22586 19 7.79362C19 3.4969 15.4062 0 10.9904 0C6.57467 0 2.98088 3.4969 2.98088 7.79362C2.98088 9.22586 3.38232 10.6395 4.16607 11.8671C5.42772 13.8574 10.092 20.3862 10.2832 20.6652C10.4552 20.8698 10.7228 21 10.9904 21ZM10.9904 1.67405C14.4695 1.67405 17.2796 4.40833 17.2796 7.79362C17.2796 8.92826 16.9546 10.0257 16.362 10.9743C15.4253 12.4624 12.3859 16.7405 11.0096 18.6935C9.6141 16.7405 6.57467 12.4624 5.63799 10.9743C5.02628 10.0257 4.72043 8.90965 4.72043 7.79362C4.72043 4.40833 7.53047 1.67405 10.9904 1.67405Z" fill="var(--icon-color, currentColor)"/>
          <path d="M10.9905 10.2861C9.53362 10.2861 8.35255 9.13686 8.35255 7.71922C8.35255 6.30157 9.53362 5.15234 10.9905 5.15234C12.4475 5.15234 13.6285 6.30157 13.6285 7.71922C13.6285 9.13686 12.4475 10.2861 10.9905 10.2861Z" fill="var(--icon-color, currentColor)"/>
        </svg>
      );
    default:
      throw new Error(`Unknown icon: ${props.icon}`);
  }

};

IconV2.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default Icon;
